// extracted by mini-css-extract-plugin
export default {"blogRiver":"blogRiver__2-Wjj"};